module.exports = __webpack_public_path__ + "img/02.7b16d521.png";